export const HOST = 'http://localhost:3000/';

export const CURRENT_LANGUAGE = 1;
export const TIME_ALWAYS_VISIBLE = 2;
export const CALL_KEY_MAX_LENGHT = 40;
export const STR_SOFTPHONE = 'softphone';
export const SM_QUEUE_SERVER = 'server';

export const SOFTPHONES_DEFAULT = {
	4: 'WebRTC',
	5: 'MizuJS'
};

export const SOFTPHONES_KEY = {
	WEBRTC: 4,
	MIZUJS: 5
};

export const SOFTPHONES = {
	4: 'WEBRTC',
	5: 'MIZUJS'
};
export const OTHER_ACTIONS = {
	NO_ACTION: 'NO_OTHER_ACTION',
	UPDATE_WB_INFO: 'UPDATE_WORK_BAR_INFO',
	MARK_CALL: 'MARK_CALL_OTHER',
	RESET_MARKS: 'RESET_MARKS_OTHER',
	DELETE_CHAT_NOTIFICATIONS: 'DELETE_CHAT_NOTIFICATIONS'
};

export const HANG_UP_SUBACTIONS = {
	MANUAL_CALL: 'ManualCall', //Cancel ManualCall before connecting
	FISRT_CALL: 'FirstCall',
	CALL: 'Call', //HangUp a dial
	LEAVE_MESSAGE: 'LeaveMessage'
};

export const CONSULTING_WINDOW = {
	CONSULTING: 'CONSULTING_UA',
	NO_CONSULTING: 'NO_CONSULTING_UA'
};

export const ACTIONS_FROM_SM = {
	NO_ACTION: 'NO_ACTION_FROM_ST',
	CALL_TYPE: 'CALL_TYPE_UA',
	MESSAGE_FROM_SUPERVISOR: 'MESSAGE_FROM_SUPERVISOR',
	NO_AVAILABLE_INFO: 'NO_AVAILABLE_INFO'
};

export const ACTIONS_FROM_WHITE_LABEL = {
	SET_CUSTOM_IMAGES: 'SET_CUSTOM_IMAGES'
};
export const ACTIONS_FROM_LOCAL_LOGGING = {
	SET_LOCAL_LOGGING: 'SET_LOCAL_LOGGING'
};

export const ACTIONS_FROM_UNIFIED_INBOX = {
	SHOW: 'SHOW',
	TYPING: 'TYPING',
	SELECT_CONVERSATION: 'SELECT_CONVERSATION',
	END_CONVERSATION: 'END_CONVERSATION',
	CHAT_CUSTOMER_TERMINATION: 'CHAT_CUSTOMER_TERMINATION',
	CHAT_CLIENT_DISCONNECT: 'CHAT_CLIENT_DISCONNECT',
	NEW_CONVERSATION: {
		0: 'CHAT',
		1: 'CHAT',
		2: 'MAIL',
		3: 'TWITTER',
		4: 'WHATSAPP'
	},
	NEW_MESSAGE_INBOX: {
		0: 'CHAT_MESSAGE',
		1: 'CHAT_MESSAGE',
		2: 'MAIL_MESSAGE',
		3: 'TWITTER_MESSAGE'
	},
	NEW_DRAFT_MESSAGE: 'NEW_DRAFT_MESSAGE',
	DELETE_DRAFT_MESSAGE: 'DELETE_DRAFT_MESSAGE',
	UPDATE_DRAFT_MESSAGE: 'UPDATE_DRAFT_MESSAGE',
	UPDATE_DRAFT_ATTACHMENTS: 'UPDATE_DRAFT_ATTACHMENTS',
	GET_DRAFT_MESSAGES_LIST: 'GET_DRAFT_MESSAGES_LIST',
	SPAM_CONVERSATION: 'SPAM_CONVERSATION',
	UNASSIGN_CONVERSATION: 'UNASSIGN_CONVERSATION',
	DISCARD_CONVERSATION: 'DISCARD_CONVERSATION',
	ANSWERS_TEMPLATES_CHAT: 'ANSWERS_TEMPLATES_CHAT',
	CHAT_TAKEOVER: 'CHAT_TAKEOVER',
	SEND_UNIFIED_RESPONSE: 'SEND_UNIFIED_RESPONSE',
	LOGOUT: 'LOGOUT',
	MULTIMEDIA_DISPOSITION: 'MULTIMEDIA_DISPOSITION',
	ACEPTED_CHAT: 'ACEPTED_CHAT',
	CHANGE_STATE_MULTIMEDIA: 'CHANGE_STATE_MULTIMEDIA',
	EXTERNAL_MESSAGING_CUSTOMER: 'EXTERNAL_MESSAGING_CUSTOMER',
	MULTIMEDIA_MESSAGE_ERROR_MMC : 'MULTIMEDIA_MESSAGE_ERROR_MMC',

	EXTERNAL_NEW_MESSAGING:'EXTERNAL_NEW_MESSAGING',
	CHANGE_STATE:'CHANGE_STATE',
	UPLOAD_ATTACHMENT:'UPLOAD_ATTACHMENT',
	CONVERSATION_TIMEOUT_REACHED: 'CONVERSATION_TIMEOUT_REACHED',
	END_CONVERSATIONS_CAMPAIGN_DELETED: 'END_CONVERSATIONS_CAMPAIGN_DELETED',
	UPDATE_CONVS_DELETED_BY_ERROR: 'UPDATE_CONVS_DELETED_BY_ERROR',
	RESET_TIMEOUT: 'RESET_TIMEOUT',
	FETCHING_CONVERSATION: 'FETCHING_CONVERSATION',
	NEW_HISTORICAL_CONVERSATION: 'NEW_HISTORICAL_CONVERSATION',
	ERROR_HISTORICAL_CONVERSATION: 'ERROR_HISTORICAL_CONVERSATION',
	UPDATE_PERMISSION: 'UPDATE_PERMISSION',
	UPDATE_CONVERSATIONS_PHONE_CHANGE: 'UPDATE_CONVERSATIONS_PHONE_CHANGE',
	CHANGE_STATE_MULTIMEDIA_ALL: 'CHANGE_STATE_MULTIMEDIA_ALL',
	CHAT_CONVERSATION_READ: 'CHAT_CONVERSATION_READ',
};

export const DRAGGABLE_WINDOWS_ACTIONS = {
	NONE: 'NONE_WINDOW_DRAGGABLE',
	INSERT_WINDOW: 'INSERT_WINDOW_DRAGGABLE',
	REMOVE_WINDOW: 'REMOVE_WINDOW_DRAGGABLE'
};

export const MESSAGES_TO_SM = {
	NO_MESSAGE: 'NO_MESSAGE',
	MESSAGE_TO_SM: 'MESSAGE_TO_SM_ACTION',
	NO_AVAILABLE_EVENT: 'NO_AVAILABLE_EVENT',
	RETRY_FIRST_CALL: 'RETRY_FIRST_CALL',
	AGENT_READY: 'AGENT_READY_MESSAGE',
	MESSAGE_TO_SUPERVISOR: 'MESSAGE_TO_SUPERVISOR',
	CHANGE_STATE: 'CHANGE_STATE_MESSAGE',
	START_STOP_RECORDING: 'START_STOP_RECORDING',
	API_REQUEST: 'API_REQUEST',
	MARKS_CALL: 'MARKS_CALL_TO_SM',
	UPDATE_DATA_CALL: 'UPDATE_DATA_CALL',
	TRANSFER_CALL: 'TRANSFER_CALL',
	MANUAL_CALL: 'MANUAL_CALL ',
	HANG_UP: 'HANG_UP',
	ASSISTED_TRANSFER_CALL: 'ASSISTED_TRANSFER_CALL',
	ONGOING_CALL_IVR: 'ONGOING_CALL_IVR',
	END_CONVERSATION_CHAT: 'END_CONVERSATION_CHAT',
	REJECT_CONVERSATION: 'REJECT_CONVERSATION',
	SPAM_CONVERSATION: 'SPAM_CONVERSATION',
	UNASSIGN_CONVERSATION: 'UNASSIGN_CONVERSATION',
	DISCARD_CONVERSATION: 'DISCARD_CONVERSATION',
	SELECTED_MESSAGE: 'SELECTED_MESSAGE',
	SEND_UNIFIED_RESPONSE: 'SEND_UNIFIED_RESPONSE',
	SEND_DISPOSITION: 'SEND_DISPOSITION',
	SEND_EXTERNAL_UNIFIED_RESPONSE: 'SEND_EXTERNAL_UNIFIED_RESPONSE',
	ACEPTED_CHAT: 'ACEPTED_CHAT',
	DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
	WHATSAPP: 'WHATSAPP',
	CHANGE_STATE_MULTIMEDIA: 'CHANGE_STATE_MULTIMEDIA',
	CHANGE_DIALINGMODE_SCH:"CHANGE_DIALINGMODE_SCH",
	PREVIEW_RECORD:"PREVIEW_RECORD",
	PREVIEW_TRANSFER:"PREVIEW_TRANSFER",
	SEND_RESPONSE_TRANSFER: "SEND_RESPONSE_TRANSFER",
	ACCEPT_CHAT_SAVE_TIME: "ACCEPT_CHAT_SAVE_TIME",
	GET_MORE_MESSAGES: 'GET_MORE_MESSAGES',
	CHANGE_STATE_MULTIMEDIA_ALL: 'CHANGE_STATE_MULTIMEDIA_ALL',
	MANUAL_MESSAGE: 'MANUAL_MESSAGE',
	API_REQUEST_ANI_LIST: 'API_REQUEST_ANI_LIST',
	GET_RECORD_CALL_PERMISSION: 'GET_RECORD_CALL_PERMISSION',
	GET_PREVIEW_CAMPAIGNS: 'GET_PREVIEW_CAMPAIGNS'
};

export const USER_ACTIONS = {
	NONE: 'NONE_USER_ACTION',
	LOGIN: 'LOGIN_UA',
	CHANGE_LANGUAGE: 'CHANGE_LANGUAGE_UA',
	LOGOUT: 'LOGOUT',
	SHOW_PSW_RESET: 'SHOW_PSW_RESET'
};

export const USER_STATE = {
	CHANGE_STATE: 'CHANGE_STATE',
	CALL_OUT: 'CALL_OUT',
	LOGED_OUT: 'LOGED_OUT',
	LOGED_IN: 'LOGED_IN',
	AGENT_READY: 'AGENT_READY',
	NO_AVAILABLE: 'NO_AVAILABLE',
	DIALOG: 'DIALOG',
	MANUAL_CALL: 'MANUAL_CALL',
	WAITING_TRANSFER: 'WAITING_TRANSFER',
	ERROR: 'ERROR',
	CALL_TRANSFER: 'CALL_TRANSFER',
	RINGING: 'RINGING',
	WRAPUP: 'WRAPUP',
	XFER: 'XFER',
	OTHER: 'OTHER',
	EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK',
	CHATTING: 'CHATTING',
	READY_PREVIEW: 'READY_PREVIEW',
	ASSISTED: 'ASSISTED',
	DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
	WHATSAPP: 'WHATSAPP',
	AGENT_PREVIEW: 'AGENT_PREVIEW',
	INACTIVE: 'INACTIVE',
	DIALOG_EMAIL: 'DIALOG_EMAIL',
	OTHER_PREVIEW:'OTHER_PREVIEW'
};

export const INTEGRATION = {
	ASSISTED_DIAL_ACD: 'assistedDialACD',
	ASSISTED_DIAL_AGENT: 'assistedDialAgent',
	ASSISTED_DIAL_NUMBER: 'assistedDialNumber',
	ASSISTED_TRANSFER_CALL_HANGUP: 'AssistedTransferCallHangUp',
	CALL_ACTION: 'CallAction',
	CALL_RECORD: 'onCallHistory',
	CHANGE_PASSWORD: 'ChangePassword',
	CHAT: 'Chat',
	DISPOSITION: 'Disposition',
	DROP_SECOND_CALL:'DropSecondCall',
	DTMF: 'DTMF',
	EXIT_ASSISTED_MODE:'exitAssistedMode',
	GET_ACD_DISPOSITIONS:'getACDDispositions',
	GET_CAMPAIGN_DISPOSITIONS:'getCampaignDispositions',
	GET_DISPOSITIONS:'getDispositions',
	GET_DISPOSITIONS_AND_NUMBERS: 'GetDispositionsAndNumbers',
	GET_IVR_LIST: 'GetIVRList',
	GET_PHONE_NUMBERS: 'getPhoneNumbers',
	GET_TRANSFER_DATA: 'GetTransferData',
	HANG_UP: 'HangUp',
	HANG_UP_AND_LEAVE_MESSAGE: 'hangUpAndLeaveMessage',
	HANG_UP_MANUAL_DIAL: 'HangUpManualDial',
	HOLD: 'Hold',
	IDLE_START: 'IdleStart',
	LOGIN: 'Login',
	LOGOUT: 'Logout',
	MAKE_CALL: 'MakeCall',
	MANUAL_CALL: 'ManualCall',
	MARK_ADD: 'MarkAdd',
	MICROPHONE: 'Microphone',
	MUTE: 'Mute',
	OPEN_VOLUME_WINDOW: 'OpenVolumeWindow',
	OPEN_WINDOW: 'OpenWindow',
	RECORDING_STOP_START: 'recordingStopStart',
	RESCHEDULE_CALL_ACD: 'reprogramCall',
	SAVE_DISPOSITION:'saveDisposition',
	READY_WITH_PASSWORD:'setReadyWithPassword',
	SET_VOLUME: 'SetVolume',
	SETTINGS: 'Settings',
	SPEAKER: 'Speaker',
	UPDATE_DATA_CALL: 'UpdateDataCall'
};

export const INTEGRATION_SUBACTION = {
	CHAT_NEW_MESSAGE: 'NewMessage',
	CHAT_SUPERVISORS: 'SupervisorsToChat',
	ERROR_SUPERVISOR_LIST_EVENT: 'errorOnChatAdministratorsList',
	TIME_ZONE_NUMBER_EVENT: 'timeZoneNumber'
};

export const PREVIEW_TRANSFER_SUBACTION = {
	TRANSFER_REQUEST: 'RequestAgent',
	TRANSFER_RESPONSE: 'AnswerAgentTransfer'
}

export const ASSISTED_TRANSFER_SUBACTION ={
	ASSISTED: 'assistedCallTransfer',
	PREVIEW: 'TransferPreviewCall'
}

export const ASSISTED_TRANSFER = {
	CHANGE_STATE: 'ASSISTED_TRANSFER_CHANGE_STATE',
	SECOND_CALL_CONNECTED: 'SECOND_CALL_CONNECTED',
	ON_STATUS: 'ON_STATUS',
	SECOND_CALL_HANG_UP: 'SECOND_CALL_HANG_UP',
	CONFERENCE_CALL_CONNECTED: 'CONFERENCE_CALL_CONNECTED',
	CONFERENCE_CALL_HANG_UP: 'CONFERENCE_CALL_HANG_UP',
	NEW_SECOND_CALL_SET: 'NEW_SECOND_CALL_SET',
	MAIN_CALL: 'MAIN_CALL',
	ON_CONFERENCE: 'ON_CONFERENCE',
	ON_CONFERENCE_CALL: 'ON_CONFERENCE_CALL',
	TRANSFERRING: 'TRANSFERRING',
	IDDLE_END: 'IDDLE_END'

};

export const TRANSFER_ACTIONS = {
	BLIND_TRANSFER: 'BLIND_TRANSFER',
	RESET_BLIND_TRANSFER: 'RESET_BLIND_TRANSFER',
	ASSISTED_TRANSFER: 'ASSISTED_TRANSFER',
	RESET_ASSISTED_TRANSFER: 'RESET_ASSISTED_TRANSFER',
	SHOW_DATA_TRANSGER_BY_SETTING: 'SHOW_DATA_TRANSGER_BY_SETTING'
}

export const BLIND_TRANSFER ={
	BLIND_TRANSFER_HANG_UP: 'BLIND_TRANSFER_HANG_UP',
}

export const WORKBAR_ACTIONS = {
	INSERT_WINDOW: 'INSERT_WINDOW_WORKBAR',
	REMOVE_WINDOW: 'REMOVE_WINDOW_WORKBAR',
	NONE: 'NONE_WORK_BAR_ACTIONS',
	SUPERVISOR_CHAT: 'SUPERVISOR_CHAT_WORK_BAR',
	NO_AVAILABLE: 'NO_AVAILABLE_WORK_BAR',
	NO_AVAILABLE_RECORD: 'NO_AVAILABLE_RECORD_EXPANDED'
	// CALL_RECORD: "CALL_RECORD",
	// MANUAL_CALL:"MANUAL_CALL",
	// MARK_CALL:"MARK_CALL"
};

export const PREVIEW_TRANSFER = {
	DATA_CALL_PREVIEW: "DATA_CALL_PREVIEW",
	ON_RESPONSE_TRANSFER: "ON_RESPONSE_TRANSFER",
	SHOW_ALERT: "SHOW_ALERT",
	SHOW_PREVIEW_DATA: "SHOW_PREVIEW_DATA",
	SET_AGENT_LIST: "SET_AGENT_LIST",
	TRANSFER_IN_PROGRESS: "TRANSFER_IN_PROGRESS",
	UNNASIGN_BY_XFER:"UNNASIGN_BY_XFER"
}

export const VALIDATING_TELEPHONY = {
	VALIDATING: 'VALIDATING_TELEPHONY',
	VALID: 'VALID_TELEPHONY',
	ERROR: 'ERROR_TELEPHONY'
};

export const CALL_ACTIONS = {
	DATA_CALL: 'DATA_CALL',
	EXTRA_DATA_CALL: 'EXTRA_DATA_CALL'
};

export const ACTION_CALL_ACD = {
	MUTE: 'MUTE',
	HOLD: 'HOLD',
	DTMF: 'DTMF'
};

export const VOLUME = {
	SPEAKER: 'SPEAKER_VOLUME',
	MICROPHONE: 'MICROPHONE_VOLUME'
};

export const REDUCERS = {
	ACTIOS_FROM_SM: 'REDUCER_ACTIOS_FROM_SM',
	CALL_ACD: 'CALL_ACD',
	CONSULTING_WINDOW: 'REDUCER_CONSULTING_WINDOW',
	MESSAGES_TO_SM: 'REDUCER_MESSAGES_TO_SM',
	NO_AVAILABLE: 'REDUCER_NO_AVAILABLE',
	OTHER_ACTIONS: 'REDUCER_OTHER_ACTIONS',
	USER_ACTIONS: 'REDUCER_USER_ACTIONS',
	USER_STATES: 'REDUCER_USER_STATES',
	WORK_BAR_SELECTED: 'REDUCER_WORK_BAR_SELECTED',
	VALIDATING_TELEPHONY: 'REDUCER_VALIDATING_TELEPHONY',
	VOLUME: 'REDUCER_VOLUME',
	WINDOW_VISIBLE: 'REDUCER_WINDOW_VISIBLE_500',
	DRAGGABLE_WINDOWS_CONTROLLER: 'REDUCER_DRAGGABLE_WINDOWS_CONTROLLER',
	SIP_CLIENT_ACTIONS: 'SIP_CLIENT_ACTIONS',
	BLOCKING_PANEL: 'BLOCKING_PANEL',
	PREVIEW_DATA: 'PREVIEW_DATA'
};

export const API_ENDPOINTS = {
	HOLD: 'Hold',
	SAVE_DISPOSITION: 'SaveDispositionListACD',
	CALL_OUT_CAMPAIGNS: 'CallOutCampaigns',
	CALL_BACK: 'InsertCallBack',
	TRANSFER_CALL_PREVIEW: 'TransferCallData',
	UPDATE_CALL_KEY: 'UpdateCallKey',
	SELECT_ANI_MANUAL_CALL: 'SelectAniManualCall',
	GET_RECORD_CALL_PERMISSION: 'GetRecordCallPermission',
};

export const BLOCKING_PANEL = {
	Z_INDEX: 'Z_INDEX'
};
export const TYPE_CALL = {
	INBOUND: 1,
	OUTBOUND: 2
};

export const TYPE_DESIGN_CALL = {
	INBOUND: 'inboundDesign',
	OUTBOUND: 'outboundDesign',
	WRAPUP: 'wrapUpDesign'
};

export const WINDOW_AT_500 = {
	NONE: 'WINDOW_VISIBLE_AT_500_NONE',
	MESSAGE: 'MESSAGE_VISIBLE_AT_500',
	CALL: 'CALL_VISIBLE_AT_500'
};

export const QUEUE_COUNT = {
	CALLS: 1,
	MESSAGES: 2,
	FACEBOOK: 3,
	LINKEDIN: 4,
	TWITTER: 5,
	MAIL: 6
};

export const SEARCH_OPTIONS = {
	BY_NAME: 'name',
	BY_PHONE: 'phone',
	BY_CALL_KEY: 'callKey',
};

export const CUSTOM_CELLS = {
	BY_NAME: 'cellDirectory',
	BY_CALL_KEY: 'cellDirectoryByCallKey'
}

export const DRAGGABLE_WINDOWS = {
	NONE: 'NONE_DRAGGABLE_WINDOW',
	MANUAL_CALL: 'MANUAL_CALL_DRAGGABLE_WINDOW',
	TRANSFER_CALL: 'TRANSFER_CALL_DRAGGABLE_WINDOW',
	DTMF_TONES: 'DTMF_TONES_DRAGGABLE_WINDOW',
	MARK_CALL: 'MARK_CALL_DRAGGABLE_WINDOW',
	NO_AVAILABLE_LOCKED: 'NO_AVAILABLE_LOCKED_NO_DRAGGABLE_WINDOW',
	NO_AVAILABLE: 'NO_AVAILABLE_DRAGGABLE_WINDOW',
	SUPERVISOR_CHAT: 'SUPERVISOR_CHAT_DRAGGABLE_WINDOW',
	NO_AVAILABLE_RECORD: 'NO_AVAILABLE_RECORD_DRAGGABLE_WINDOW',
	CALL_RECORD: 'CALL_RECORD_DRAGGABLE_WINDOW',
	EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK_NO_DRAGGABLE_WINDOW',
	ONGOING_CALL_IVR: ' ONGOING_CALL_IVR_DRAGGABLE_WINDOW',
	MANUAL_MESSAGE: 'MANUAL_MESSAGE',
	TEMPLATES_WHATSAPP: 'TEMPLATES_WHATSAPP',
	RATE_RECORD: 'RATE_RECORD',
};

export const TYPE_MARKS = {
	ADMIN: 'ADMIN_TYPE_MARK',
	AGENT: 'AGENT_TYPE_MARK'
};

export const SIP_CLIENT_ACTIONS = {
	HANGUP: 'HANGUP_FROM_SIP',
	NONE: 'NONE_FROM_SIP',
	STREAM: 'STREAM_FROM_SIP'
};

export const STEP_MANUAL_CALL = {
	FIRST_TRY: 0,
	BLACKLIST_OR_WRONG_CAMP: 2,
	INCORRECT_NUMBER: 3
};

export const ALERT_CATALOG = {
	NO_CAMPAINS: 1090,
	CHECK_NUMBER: 1091,
	INCORRECT_NUMBER: 1092,
	TIME_ZONE: 1095
};

export const ERROR_CATALOG = {
	UNABLE_VERIFY_PHONE_NUMBER: 1081,
	ON_BLACKLIST: 1090,
	NO_CELLPHONE: 1091,
	NO_LONG_DISTANCE: 1092,
	NO_LOCAL_CALLS: 1093,
    USER_OUT_CAMP: 1094,
    NO_PORTS_ASSIGNED: 1098,
	NO_CAMPAIGN: 1099,
	NO_CAMPAIGN_FOUND: 1083
};

export const BLOCKING_ALERTS = {
	1093: 'CALL_ON_NOT_READY'
};

export const BLOCKING_ERRORS = {};

export const ALERTS_SHOWED = {
	INSERT_CALL_ALERT: 'INSERT_CALL_ALERT',
	REMOVE_CALL_ALERT: 'REMOVE_CALL_ALERT',
	INSERT_NO_AVAILABLE_ALERT: 'INSERT_NO_AVAILABLE_ALERT',
	REMOVE_NO_AVAILABLE_ALERT: 'REMOVE_NO_AVAILABLE_ALERT',
	INSERT_VOLUME_ALERT: 'INSERT_VOLUME_ALERT',
	REMOVE_VOLUME_ALERT: 'REMOVE_VOLUME_ALERT',
	INSERT_PREVIEW_MODE_ALERT: 'INSERT_PREVIEW_MODE_ALERT',
	INSERT_PREVIEW_TRANSFER_ALERT:'INSERT_PREVIEW_TRANSFER_ALERT'
};

export const ALERTS_SHOWED_CODE = {
	REPROGRAM_CALL_DIALOG: 1093,
	REPROGRAM_CALL_NA: 1094,
	REPROGRAM_NA_STATE: 'NO_AVAILABLE_REPROGRAM',
	VOLUMEN_DISABLED: 'VOLUME_DISABLED',
	READY_PREVIEW_MODE: 'READY_PREVIEW_MODE',
	PREVIEW_TRANSFER: 'PREVIEW_TRANSFER' 
};

export const ACTIONS_INTEGRATION = {
	CHANGE_IS_INTEGRATION: 'CHANGE_IS_INTIGRATION',
	MESSAGE: 'MESSAGE_INTEGRATION',
	NONE: 'NONE_INTEGRATION'
};

export const STATES_INTEGRATION = {
	connected: 'connectedIntegration',
	connecting: 'connectingIntegration',
	disconnecting: 'disconnectedIntegration',
	notFound: 'notFoundIntegration'
};

export const PREVIEW = {
	SetAgentDialingMode: 'SetAgentDialingMode',
	SET_PREVIEW_RECORD: 'SET_PREVIEW_RECORD',
	UPDATE_PREVIEW_RECORD: 'UPDATE_PREVIEW_RECORD',
	INCREMENT_DISCARDED: 'INCREMENT_DISCARDED',
	UPDATE_PREVIEWTIME: 'UPDATE_PREVIEWTIME',
	SET_TEMP_DATA:  'SET_TEMP_DATA',
	CLEAN_DATA: 'CLEAN_DATA',
	SET_PHONE_CALL: 'SET_PHONE_CALL',
	CHANGE_CAMPAIGN_TYPE: 'CHANGE_CAMPAIGN_TYPE',
	SUCCESSFUL_CHANGE: 'SUCCESSFUL_CHANGE',
	SET_ISRUNNING_CLOCK: 'SET_ISRUNNING_CLOCK',
	SET_NEWPREVIEW_TIME: 'SET_NEWPREVIEW_TIME',
	SET_FINAL_TIME: 'SET_FINAL_TIME',
	SET_INITIAL_TIME: 'SET_INITIAL_TIME',
	SET_DATA_TRANSFER: 'SET_DATA_TRANSFER',
	SET_DIALOG_TIME: 'SET_DIALOG_TIME',
	SET_DIALINGMODE: 'SET_DIALINGMODE',
	SET_IS_SEND_PROCESS: 'SET_IS_SEND_PROCESS',
	SET_TEMP_PREVIEW_RECORD: 'SET_TEMP_PREVIEW_RECORD',
	SELECTED_PREVIEW_CAMPAIGN: 'SELECTED_PREVIEW_CAMPAIGN',
}
export const PREVIEW_SIMULTANEOUS_REC={
	SET_TOTAL_TIME: 'SET_TOTAL_TIME',
	SET_PHONE_TO_CALL: 'SET_PHONE_TO_CALL',
	REMOVE_RECORD: 'REMOVE_RECORD',
	SAVE_LOG_DIAL:'SAVE_LOG_DIAL',
	SET_INITIAL_TIMESEC: "SET_INITIAL_TIMESEC",
	CHANGE_RECORD_STATE: "CHANGE_RECORD_STATE",
	SELECTED_RECORD: "SELECTED_RECORD",
	MESSAGE_STATUS: "MESSAGE_STATUS",
	RESET_RECORD: "RESET_RECORD",
	SET_CALL_ID:"SET_CALL_ID",
	SET_DIALOG_TIME:"SET_DIALOG_TIME_SIMULTANEOUS",
	SET_MAXIMUM_ASSIGNMENTS:"SET_MAXIMUM_ASSIGNMENTS",
	SET_INITIAL_DIALOG_TIME:"SET_INITIAL_DIALOG_TIME",
	SET_IT_WAS_SENT_TIME:"SET_IT_WAS_SENT_TIME",
	SET_VOLUME:"SET_VOLUME",
	SET_MARKS:"SET_MARKS",
	SET_DISPOSITION_DATA:"SET_DISPOSITION_DATA",
	SET_ND_SCHEDULED:"SET_ND_SCHEDULED",
	SET_FLAG_LOGDIAL: "SET_FLAG_LOGDIAL"
}

export const ADMIN_MODAL_ACTIONS = {
	SHOW_ADMIN_MODAL: 'SHOW_ADMIN_MODAL',
	HIDE_ADMIN_MODAL: 'HIDE_ADMIN_MODAL' 
}

export const UNIFIED_INBOX_PERMISSIONS = {
	AllowUnassign: "AllowUnassign",
	AllowSpam: "AllowSpam"
}

export const CONVERSATION_TYPES = {
	CHAT: 'CHAT',
	MAIL: 'MAIL',
	TWITTER: 'TWITTER',
	WHATSAPP: 'WHATSAPP'
}

export const CONVERSATION_TYPES_IDS = {
	CHAT: 1,
	MAIL: 2,
	TWITTER: 3,
	WHATSAPP: 5
}

export const AGENT_PERMISSIONS_ACTIONS = {
	ALLOW_PLAY_RECORDS_ON_CALL_HISTORY: 'ALLOW_PLAY_RECORDS_ON_CALL_HISTORY',
	SET_ALLOW_CHANGE_DIALING: 'SET_ALLOW_CHANGE_DIALING'
}

export const AGENT_PERMISSIONS = {
	AllowPlayRecordsOnCallHistory: 'AllowPlayRecordsOnCallHistory'
}

export const LANGUAGE = {
	 0: 'es',
	 1: 'en',
	 2: 'pt'
}

export const OUTBOUND_CAMP_TYPES = {
	WHATSAPP: 5
}

export const MANUAL_MESSAGES_STATUS = {
	SEND: 0,
	SENDING: 1,
	INCORRECT_NUMBER: 2,
	NETWORK_ERROR: 3,
	PROVIDER_ERROR: 4,
	SYSTEM_ERROR: 5 
}

export const MANUAL_MESSAGES_STATUS_CODE = {
	0: 'SEND',
	1: 'SENDING',
	2: 'INCORRECT_NUMBER',
	3: 'NETWORK_ERROR',
	4: 'PROVIDER_ERROR',
	5: 'SYSTEM_ERROR' 
}

export const MANUAL_MESSAGES_STATUS_TAG = {
	2: 'error-number',
	3: 'error-connection',
	4: 'error-carrier',
	5: 'error-system',
	6: 'error-whatsapp-body1',
	7: 'error-whatsapp-body2'
}

export const MESSAGE_STATUS = {
	send: "send",
	delivered: "delivered",
	error: "error"
}

export const CAMP_TYPES = {
	IN: 0,
	OUT: 1
}

export const STATE_TO_PLAY_END_AUDIO= {
	LOADING: 0,
	HANG_UP_CLIENT: 1,
	HANG_UP_AGENT: 2
};

export const RECORD_STATE = {
	PREVIEW: 'PREVIEW-REC',
	DIALING: 'DIALING-REC',
	DIALOG: 'DIALOG-REC',
	ERROR: 'ERROR-REC',
	ALERT: "ALERT-REC",
	WRAPUP: 'WRAPUP-REC',
	TIME_OVER:"TIMEOVER-REC",
	HOLD: 'HOLD-REC',
	DEFAULT: 'DEFAULT-REC',
	ABANDONED: 'ABANDONED-REC',
	WAITING_WRAPUP: 'WAITING-WRAPUP-REC'
};

export const  STATES_TO_SHOW_CTC = [USER_STATE.AGENT_PREVIEW, USER_STATE.READY_PREVIEW];



// WEBPACK FOOTER //
// ./src/constants.js